import React, { useEffect } from 'react'
import { useAccordionContext } from '@tecsinapse/cortex-react'
import { checkbox } from '@tecsinapse/cortex-core'
import { useFormContext } from 'react-hook-form'

interface TriggerAccordionProps {
  labelCheboxbox: string
  idCheckbox: string
  value: boolean
  fieldToClear: string
}

export const TriggerAccordion = ({
  labelCheboxbox,
  idCheckbox,
  fieldToClear,
  value
}: TriggerAccordionProps) => {
  const { setValue } = useFormContext()
  const { toggle, open } = useAccordionContext()

  useEffect(() => {
    if (value === true && !open) {
      toggle?.()
    }
  }, [value, open])

  return (
    <div className={'p-deca flex items-center space-x-deca'}>
      <input
        className={checkbox()}
        checked={value}
        onChange={e => {
          setValue(idCheckbox, e.currentTarget.checked)
          if (fieldToClear && e.currentTarget.checked === false) {
            if (fieldToClear === 'possuiPerfil') {
              setValue(fieldToClear, false)
              setValue('marcas', [])
              setValue('tiposUsuarios', [])
              setValue('dealers', [])
            } else {
              setValue(fieldToClear, undefined)
            }
          }
          toggle?.()
        }}
        type={'checkbox'}
        id={idCheckbox}
      />
      <label htmlFor={idCheckbox} className={'font-bold'}>
        {labelCheboxbox}
      </label>
    </div>
  )
}
